var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWellness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 2.09998C16.0968 2.09998 16.5 2.50318 16.5 2.99998V5.69998H20.1C20.5968 5.69998 21 6.10318 21 6.59998V19.2C21 19.6968 20.5968 20.1 20.1 20.1H3.9C3.4032 20.1 3 19.6968 3 19.2V6.59998C3 6.10318 3.4032 5.69998 3.9 5.69998H7.5V2.99998C7.5 2.50318 7.9032 2.09998 8.4 2.09998H15.6ZM19.2 7.49998H4.8V18.3H19.2V7.49998ZM12.9 9.29998V12H15.6V13.8H12.8991L12.9 16.5H11.1L11.0991 13.8H8.4V12H11.1V9.29998H12.9ZM14.7 3.89998H9.3V5.69998H14.7V3.89998Z",
    fill: "#5C5C5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWellness);
export default __webpack_public_path__ + "static/media/ic-wellness.78b99f227af3714a0983f470e8da6bff.svg";
export { ForwardRef as ReactComponent };